/**
 * Constant containing the id of the currently build version.
 */
export type Version = string;

export const VersionProvider: {
  provide: string;
  useValue: Version;
} = {
  provide: 'version',
  useValue: 'v26.15.0-10-gb03b8c9',
};
